import { render, staticRenderFns } from "./Cuisine.vue?vue&type=template&id=ae1fc8a4&scoped=true"
import script from "./Cuisine.vue?vue&type=script&lang=js"
export * from "./Cuisine.vue?vue&type=script&lang=js"
import style0 from "./Cuisine.vue?vue&type=style&index=0&id=ae1fc8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1fc8a4",
  null
  
)

export default component.exports